import Vue from 'vue'
export var bus = new Vue()

// common VAR
export var api_dir="../kggsee/api/"


// WEBPACK FOOTER //
// ./src/bus.js